export const setRadius = ({ radius }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      radius,
    },
  };
};
